<template>
  <div class="pa-4">
    <h2 class="mb-3 text-center">
      {{ $t('servicesystem.loginform.text.welcome_back') }}
    </h2>
    <p class="text-center">
      {{ $t('servicesystem.loginform.text.enter_details') }}
    </p>

    <v-form v-model="valid" ref="form">
      <v-text-field ref="emailfield" :label="$t('servicesystem.loginform.text.login_email')" v-model="mailtext"
        :rules="emailRule" :placeholder="autofill ? ' ' : null" :persistent-placeholder="autofill" required>
      </v-text-field>
      <v-text-field ref="passwordfield" :label="$t('servicesystem.loginform.text.login_password')" v-model="password"
        min="8" :append-icon="showpw ? 'mdi-eye' : 'mdi-eye-off'" @click:append="() => (showpw = !showpw)"
        :type="showpw ? 'password' : 'text'" :rules="noEmptyRule" :placeholder="autofill ? ' ' : null"
        :persistent-placeholder="autofill" counter required autocomplete="on" @keydown.enter="submit">
      </v-text-field>

      <v-layout justify-space-between>
        <v-spacer />
        <v-btn @click="$emit('recoverpw')" v-text="$t('servicesystem.loginform.text.forgot_password')" color="primary"
          style="text-transform: none !important;" class="mr-n4" text>
        </v-btn>

      </v-layout>

      <WideBtn :text="$t('servicesystem.common_objects.commonterms.login')" color="var(--v-primary-base)"
        :disabled="!valid" :loading="loginInProgress" @click="submit()">
      </WideBtn>

      <v-row no-gutters align="center" class="my-5">
        <v-divider></v-divider>
        <v-col cols="auto" class="mx-2">
          {{ $t('servicesystem.loginform.text.or') }}
        </v-col>
        <v-divider></v-divider>
      </v-row>

      <v-row no-gutters justify="center">
        <v-btn style=" text-transform: none; border-color: grey;" outlined @click="sso">
          <v-img :src="msLogo" max-height="20" max-width="20" class="mr-2">
          </v-img>
          {{ $t('servicesystem.loginform.text.microsoft_signin') }}
        </v-btn>
      </v-row>

      <v-snackbar v-model="snackbar">{{ snackbarText }}</v-snackbar>
    </v-form>
  </div>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin";
import client from "@/api/client";
import msLogo from "@/assets/ms_logo.svg";
import WideBtn from "@/components/WideBtn.vue";
import rules from "@/helpers/Mixins/RuleMixin.js";
import { PublicClientApplication } from '@azure/msal-browser';

export default {
  name: "LoginForm",
  model: {
    prop: "email",
    event: "change",
  },
  props: {
    email: String,
  },
  components: {
    WideBtn,
  },
  mixins: [rules, clientAPI],

  data() {
    return {
      snackbar: false,
      snackbarText: "",
      loginInProgress: false,
      valid: false,
      showpw: true,
      password: "",
      loading: false,
      autofill: false,
      intervalDetectAutofill: null,
      msLogo
    };
  },

  created() {
    this.$msalInstance = new PublicClientApplication(
      this.$store.state.msalConfig,
    );
  },

  mounted() {
    this.intervalDetectAutofill = setInterval(() => {
      if (document.querySelectorAll('input[type="password"]:-webkit-autofill').length > 0) {
        this.autofill = true;
      }
    }, 100);

    // clean interval if needed after 3s
    setTimeout(() => {
      if (this.intervalDetectAutofill) {
        clearInterval(this.intervalDetectAutofill);
        this.intervalDetectAutofill = null;
      }
    }, 3000);
  },

  methods: {
    submit() {
      if (this.$refs.form.validate()) {
        this.loginInProgress = true;
        // call login
        const inputUserName = this.$refs.emailfield.value;
        const inputPassword = this.$refs.passwordfield.value;
        this.$store
          .dispatch("serviceProviderLogin", {
            username: inputUserName,
            password: inputPassword,
          })
          .then((result) => {
            if (result.success) {
              this.snackbarText = "Login success";
              this.snackbar = true;
            } else {
              this.snackbarText = result.errorMessage;
              this.snackbar = true;
            }
          })
          .finally(() => {
            this.loginInProgress = false;
          });
      }
    },

    async sso() {
      var accounts = await this.SignIn();
      //console.log("Signed in:", accounts);
      client().get("/api2/token/EntraId/ServiceProvider.WebSite/?accessToken=" + accounts[0].idToken).then(response => {
        this.$store.dispatch("EntryIdLogin", response.data).then(() => {
          this.loginInProgress = false;
        });
      });

    },

    async SignIn() {
      const loginRequest = {
        prompt: 'select_account',
      }
      return await this.$msalInstance
        .loginPopup(loginRequest)
        .then(() => {
          const myAccounts = this.$msalInstance.getAllAccounts();
          return myAccounts;
        })
        .catch(error => {
          console.error(`error during authentication: ${error}`);
        });
    },
  },

  computed: {
    mailtext: {
      get() {
        return this.email;
      },
      set(val) {
        this.$emit("change", val);
      },
    },
  },

  watch: {
    password() {
      this.autofill = false;
    },
    autofill() {
      //console.log("autofill", this.autofill);
      // clean interval if autofill detected or user input
      if (this.intervalDetectAutofill) {
        clearInterval(this.intervalDetectAutofill);
        this.intervalDetectAutofill = null;
      }
    },
  },
};
</script>


<style lang="scss" scoped></style>